/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-11 09:16:48
 * @LastEditTime: 2025-05-31 22:18:55
 * @LastEditors: 杰
 */
import type { GlobConfig } from '/@/types';

const { VITE_APP_TITLE, VITE_APP_URL, VITE_APP_VERSION, VITE_APP_MODULES } = import.meta.env;

export const globalData: Readonly<GlobConfig> = {
  title: VITE_APP_TITLE as string,
  apiUrl: VITE_APP_URL as string,
  version: VITE_APP_VERSION as string,
  modules: VITE_APP_MODULES as string,
};
